import React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import InfoIcon from "@mui/icons-material/Info";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function Equipment({ data }) {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card variant="outlined" style={{ height: "100%", borderRadius: 20 }}>
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        <img
          style={{ width: 150, height: 150, borderRadius: 5 }}
          alt="equipIcons"
          src={data.icon}
        />
      </Stack>
      <CardHeader title={data.name} style={{ textAlign: "center" }} />
      <CardContent>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Chip label={data.rarity} color="secondary" />
          <Chip label={data.occupation} color="secondary" />
          {data.type === "arms" ? (
            <Chip label="Weapon" color="secondary" />
          ) : data.type === "armor" ? (
            <Chip label="Armor" color="secondary" />
          ) : data.type === "accesory" ? (
            <Chip label="Accesory" color="secondary" />
          ) : null}
        </Stack>
        {data.type === "arms" ? (
          <>
            <Divider style={{ marginTop: 30 }}>
              <Chip label="ATTRIBUTES" color="primary" size="medium" />
            </Divider>
            <Typography
              variant="h6"
              color="text.secondary"
              style={{ marginTop: 5, textAlign: "center" }}
            >
              HP : {data.hp}
            </Typography>
            <Typography
              variant="h6"
              color="text.secondary"
              style={{ marginTop: 5, textAlign: "center" }}
            >
              ATK : {data.atk}
            </Typography>
          </>
        ) : (
          <>
            <Divider style={{ marginTop: 30 }}>
              <Chip label="ATTRIBUTES" color="primary" size="medium" />
            </Divider>
            <Typography
              variant="h6"
              color="text.secondary"
              style={{ marginTop: 5, textAlign: "center" }}
            >
              {data.hp}
            </Typography>
            <Typography
              variant="h6"
              color="text.secondary"
              style={{ marginTop: 5, textAlign: "center" }}
            >
              {data.atk}
            </Typography>
          </>
        )}
        {data.imprint !== null ? (
          <>
            <Divider style={{ marginTop: 30 }}>
              <Chip
                label={"IMPRINT : " + data.imprint.name}
                color="warning"
                size="medium"
              />
            </Divider>
            <Typography
              variant="body2"
              color="text.secondary"
              style={{ marginTop: 5, textAlign: "center" }}
            >
              {data.imprint.description}
            </Typography>{" "}
          </>
        ) : (
          <>
            <Divider style={{ marginTop: 30 }}>
              <Chip label="IMPRINT" color="warning" size="medium" />
            </Divider>
            <Typography
              variant="body2"
              color="text.secondary"
              style={{ marginTop: 5, textAlign: "center" }}
            >
              N/A
            </Typography>
          </>
        )}
      </CardContent>
      <CardActions disableSpacing>
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <InfoIcon />
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>Description :</Typography>
          <Typography paragraph>{data.description}</Typography>
          <Chip color="error" label="Code " /> {data.serialNumber}
        </CardContent>
      </Collapse>
    </Card>
  );
}
